import {
  PositionAnchor,
  TargetProps,
} from '@omni/kit/components/Popover/types';
import Spacing from '@omni/kit/theming/Spacing';
import { Animated } from 'react-native';

interface UseAnimatedPostionProps {
  targetRef: TargetProps;
  targetOffset?: number;
  width: number;
  height: number;
  position?: PositionAnchor;
}

interface UseAnimatedPostionReturn {
  left: Animated.AnimatedNode;
  top: Animated.AnimatedNode;
}

const DEFAULT_OFFSET = Spacing.s;

export default ({
  targetRef,
  targetOffset = DEFAULT_OFFSET,
  width,
  height,
  position = 'top-start',
}: UseAnimatedPostionProps): UseAnimatedPostionReturn => {
  switch (position) {
    case 'top':
      return {
        left: Animated.subtract(
          targetRef.left,
          Animated.divide(Animated.subtract(width, targetRef.width), 2)
        ),
        top: Animated.subtract(
          Animated.subtract(targetRef.top, height),
          targetOffset
        ),
      };
    case 'top-start':
      return {
        left: targetRef.left,
        top: Animated.subtract(
          Animated.subtract(targetRef.top, height),
          targetOffset
        ),
      };
    case 'top-end':
      return {
        left: Animated.subtract(
          Animated.add(targetRef.left, targetRef.width),
          width
        ),
        top: Animated.subtract(
          Animated.subtract(targetRef.top, height),
          targetOffset
        ),
      };
    case 'bottom':
      return {
        left: Animated.subtract(
          targetRef.left,
          Animated.divide(Animated.subtract(width, targetRef.width), 2)
        ),
        top: Animated.add(
          targetRef.top,
          Animated.add(targetRef.height, targetOffset)
        ),
      };
    case 'bottom-start':
      return {
        left: targetRef.left,
        top: Animated.add(
          targetRef.top,
          Animated.add(targetRef.height, targetOffset)
        ),
      };
    case 'bottom-end':
      return {
        left: Animated.subtract(
          Animated.add(targetRef.left, targetRef.width),
          width
        ),
        top: Animated.add(
          targetRef.top,
          Animated.add(targetRef.height, targetOffset)
        ),
      };
    case 'left':
      return {
        left: Animated.subtract(
          targetRef.left,
          Animated.add(width, targetOffset)
        ),
        top: Animated.subtract(
          targetRef.top,
          Animated.divide(Animated.subtract(height, targetRef.height), 2)
        ),
      };
    case 'left-start':
      return {
        left: Animated.subtract(
          targetRef.left,
          Animated.add(width, targetOffset)
        ),
        top: targetRef.top,
      };
    case 'left-end':
      return {
        left: Animated.subtract(
          targetRef.left,
          Animated.add(width, targetOffset)
        ),
        top: Animated.add(
          targetRef.top,
          Animated.subtract(targetRef.height, height)
        ),
      };
    case 'right':
      return {
        left: Animated.add(
          targetRef.left,
          Animated.add(targetRef.width, targetOffset)
        ),
        top: Animated.subtract(
          targetRef.top,
          Animated.divide(Animated.subtract(height, targetRef.height), 2)
        ),
      };
    case 'right-start':
      return {
        left: Animated.add(
          targetRef.left,
          Animated.add(targetRef.width, targetOffset)
        ),
        top: targetRef.top,
      };
    case 'right-end':
      return {
        left: Animated.add(
          targetRef.left,
          Animated.add(targetRef.width, targetOffset)
        ),
        top: Animated.add(
          targetRef.top,
          Animated.subtract(targetRef.height, height)
        ),
      };
    default:
      return {
        left: new Animated.Value(0),
        top: new Animated.Value(0),
      };
  }
};
